import { useQuery } from "@tanstack/react-query";
import { commimentsExposure } from "../api/commimentsExposure";
import { CommitmentGraphData } from "../types";

export const useCommitmentsGraph = () => {

    const { data, isLoading, isError, error, isSuccess } = useQuery({
        queryKey: ["commitments-exposure-graph"],
        queryFn: () => commimentsExposure.getCommimentsExposureGraphData(),
    });

    return { data : data as CommitmentGraphData, isLoading, isError, error };

};